import {
  StatusChipV2,
  StatusChipV2Color,
  StatusChipV2Size,
  StatusChipV2Variant,
  Tooltip,
} from '@cast/design-system';
import { KentKentrollerStatusDetails } from '@cast/types-kent';

import { DerivedKentrollerStatus } from '../types';
import { deriveKentrollerStatus } from '../utils/utils';

import { KentrollerLastFalseConditionDetails } from './KentrollerLastFalseConditionDetails';

const STATUS_CHIP_COLOR: Record<DerivedKentrollerStatus, StatusChipV2Color> = {
  not_ready: 'error',
  warning: 'warning',
  ready: 'success',
};

const DERIVED_KENTROLLER_STATUS_LABEL: Record<DerivedKentrollerStatus, string> =
  {
    not_ready: 'Failed',
    warning: 'Warning',
    ready: 'Ready',
  };

type Props = {
  statusDetails: KentKentrollerStatusDetails;
  showLastFailedConditionDetailsTooltip?: boolean;
  size?: StatusChipV2Size;
  variant?: StatusChipV2Variant;
};

export const DerivedKentrollerStatusChip = ({
  statusDetails,
  size = 'medium',
  variant = 'subtle',
  showLastFailedConditionDetailsTooltip = true,
}: Props) => {
  const kentrollerStatus = deriveKentrollerStatus(statusDetails);
  const lastFalseCondition = statusDetails.lastFalseCondition;
  const shouldShowTooltip =
    showLastFailedConditionDetailsTooltip &&
    kentrollerStatus !== 'ready' &&
    !!lastFalseCondition;

  const statusChip = (
    <StatusChipV2
      testId="kent-kentroller-status-chip"
      label={DERIVED_KENTROLLER_STATUS_LABEL[kentrollerStatus]}
      color={STATUS_CHIP_COLOR[kentrollerStatus]}
      size={size}
      variant={variant}
    />
  );

  if (!shouldShowTooltip) {
    return statusChip;
  }

  return (
    <Tooltip
      title={
        <KentrollerLastFalseConditionDetails
          lastFalseCondition={lastFalseCondition}
          maxHeight={150}
        />
      }
    >
      {statusChip}
    </Tooltip>
  );
};
